let idVal = 0;
export const courseData = [
  {
    id: ++idVal,
    session: "Session One",
    duration: "Two Weeks",
    scheme: [
      "Intro to Software Development",
      "System Development Life Cycle (SDLC)",
      "Intro to Business Analysis",
      "Stakeholder Analysis",
      "Ms Word Crash Course",
      "Workspace Simulation",
      "SQL Install",
    ],
  },
  {
    id: ++idVal,
    session: "Session Two",
    duration: "Two Weeks",
    scheme: [
      "Scrum Fundamentals",
      "Managing Project Artifacts",
      "Ms Visio Tutorials",
      "GUI Design Tutorials",
      "Project Management Tools",
      "Work Simulation",
      "Intro to Jira",
    ],
  },
  {
    id: ++idVal,
    session: "Session Three",
    duration: "Two Weeks",
    scheme: [
      "The Development Team",
      "Managing Change at Every Stage in a Project",
      "Source to Target Mapping",
      "Requirement Tracability Matrix",
      "Workspace Simulation",
      "SQL",
    ],
  },
  {
    id: ++idVal,
    session: "Session Four",
    duration: "Two Weeks",
    scheme: [
      "Course Review",
      "End of Course Exams",
      "Resume Worshop",
      "Group Mock Interviews",
      "Insight Into Day One of Your New Job",
      "Workspace Simulation",
      "Communicating With Guide and Professionalism",
    ],
  },
];
